module.exports = __webpack_public_path__ + "media/attorney_resource_center/plaintiff-guide-book-ab716e6c.png";